/** 
 * @file Універсальний хелпер сповіщень для Toast та `#message-container`.
 * API:
 * - setNotifications(enabled)
 * - showMessage(text, type = 'info', autoHideMs = 5000)
*/
import { toast } from './cmd_palette.ts';

(function (w: any) {
    let enabled = true;
    let hideTimer: any = null;

    function el() { return document.getElementById('message-container'); }

    function setNotifications(v: boolean) {
        enabled = !!v;
        const e = el();
        if (!e) return;
        if (!enabled) e.classList.add('is-hidden');
        else e.classList.remove('is-hidden');
    }

    function showMessage(text: string, type: 'info' | 'success' | 'error' | 'warning' = 'info', autoHideMs = 5000) {
        if (!enabled) return;

        // Якщо це сторінка логіну з інлайн алертом
        if (typeof w.showLoginAlert === 'function' && document.getElementById('login-alert')) {
            const cleanText = (text || '').replace(/^Помилка:\s*/i, '');
            let title = 'Повідомлення';
            if (type === 'error') title = 'Помилка входу';
            else if (type === 'warning') title = 'Увага';
            else if (type === 'success') title = 'Успішно';
            w.showLoginAlert(title, cleanText, type, type === 'error' ? ['username', 'password'] : []);
            return;
        }

        // Trigger Toast system on main app pages
        if (typeof toast?.show === 'function' && !document.getElementById('login-alert')) {
            toast.show(text, type, autoHideMs);
        }

        // Fallback for container
        const e = el();
        if (!e) return;
        e.textContent = text;
        e.className = `message-container ${type}`;
        e.dataset.type = type;
        e.setAttribute("role", "status");
        e.setAttribute("aria-live", "polite");
        e.classList.remove('is-hidden');
        if (e.style.display) e.style.removeProperty('display');
        clearTimeout(hideTimer);
        if (autoHideMs) hideTimer = setTimeout(() => e.classList.add('is-hidden'), autoHideMs);
    }

    w.showMessage = showMessage;
    w.setNotifications = setNotifications;
})(window);

